import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h3
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "black",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h3>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Agriculture is practiced predominantly in India with a generation
              of large quantum of residues, which are partially being used as
              fodder, while the major fraction is being burnt or mismanaged,
              posing serious environmental implications. There is wide scope to
              convert bio-residues to bio-fuels to cater to the burgeoning
              demand for liquid fuel in the industrial, agricultural, and
              transportation sectors. India is next to China in the production
              of cereals such as rice and wheat, which have been serving as the
              staple source of nourishment for billions of Indians. These crops
              generate residues (stalk, husk, straws, etc.), which can be
              utilized in unprocessed or processed form depending on the end
              use. Potential uses of these residues are as animal feed,
              production of bioenergy, composting, or deployment in other
              agricultural activities such as mushroom cultivation. According to
              the National policy for management of crop residues (NPMCR), Uttar
              Pradesh state generates the highest crop residues (60 Million
              tonnes, Mt), followed by Punjab (51Mt) and Maharashtra (46 Mt) in
              India. Rice and wheat contribute to nearly 70% of the crop
              residues (Fig 1). Among the total residue generated, the surplus
              residue after utilizing for various other purposes is burnt and
              the remains are left in the agricultural fields. According to
              NPMCR, approximately 92 to 100 Mt of residues are being burnt
              annually in India. Adverse effect of crop residue burning includes
              greenhouse gases (GHGs) emissions, increase in particulate matter
              (PM) and smog, evident from higher PM levels in Delhi due to crop
              residue burning in Punjab, which is 17 times more than that from
              all other sources such as garbage burning, industries, and vehicle
              emissions. These crop residues are composed of cellulose, lignin,
              and hemicellulose, which serves as ideal raw material for biofuel
              production.
              <br />
              <br />
            </p>
            <table width="102%">
              <tbody>
                <tr>
                  <td style={styles.cell} colspan="7" width="100%">
                    <p>
                      <strong>Table 1. </strong>Crop biomass residue potential
                      in India
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>Crop group</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>
                      <strong>Crop</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>
                      <strong>Growing Season</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>
                      <strong>Residue</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="14%">
                    <p>
                      <strong>Gross potential, MT</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="17%">
                    <p>
                      <strong>Surplus potential, MT</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="19%">
                    <p>
                      <strong>Residue available for 1kg of crop</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="9%">
                    <p>Cereal</p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>Rice</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="13%">
                    <p>Kharif, Rabi, Summer</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>Straw</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="14%">
                    <p>154</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="17%">
                    <p>43.5</p>
                  </td>
                  <td style={styles.cell} width="19%">
                    <p>1.5</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="9%">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="13%">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>Husk</p>
                  </td>
                  <td style={styles.cell} width="19%">
                    <p>0.2</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="9%">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>Wheat</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="13%">
                    <p>Rabi</p>
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>Stalk</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="14%">
                    <p>131.1</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="17%">
                    <p>28.4</p>
                  </td>
                  <td style={styles.cell} width="19%">
                    <p>1.5</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="9%">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="13%">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="10%">
                    <p>Pod</p>
                  </td>
                  <td style={styles.cell} width="19%">
                    <p>0.3</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/ea1.png" alt="" />
              &nbsp; <img src="images/ea2.png" alt="" />{" "}
            </p>
            <table width="102%" colspan="7">
              <tbody>
                <tr>
                  <td style={styles.cell}>
                    <p style={{ textAlign: "center" }}>
                      <strong>Fig 1.</strong> Representation of paddy and
                      wheat-producing states across India
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>National Biofuel Policy: </strong>The share of road
              transport is around 6.7% of India&rsquo;s Gross Domestic Product
              (GDP), of which diesel meets about 72% and petrol 23%. In India,
              domestic crude oil production only meets about 17.9% of the
              demand, rest is sufficed by importing crude oil. This vulnerable
              status of India needs to change with the utilization of
              alternative fuels produced from indigenous renewable feedstock.
              The government of India has undertaken multiple interventions to
              promote biofuel production and blending of bioethanol with
              petroleum and reduce import by 10% by 2022 (India, 2018). In this
              regard, recently National Biofuel Coordination Committee (NBCC)
              constituted under National Policy on Biofuels, has allowed the
              production of ethanol from maize and surplus rice available from
              the Food Corporation of India (FCI) involving public sector oil
              marketing companies (OMCs) such as IOCL, BPCL and HPCL under the
              ethanol blended petrol (EBP) programme. Largescale bioethanol
              production in the country can be taken forward with the
              establishment of a transparent framework of policy, mandates, and
              subsidies that dwells on the production of biofuels using various
              conversion technologies and promoting utilization of locally
              available feedstocks generated in large quantities in Agri states
              of India.
            </p>
            <p>
              <strong>Production of bioethanol from bio-residues: </strong>
              Production of bioethanol entails three main processes, namely (i)
              pretreatment of raw materials to break down recalcitrant
              lignocellulose structure; (ii) enzymatic hydrolysis of
              polysaccharides (e.g., cellulose and hemicellulose) to release
              simple sugars; (iii) fermentation of these simple sugars to
              bioethanol (Fig 2). A major limitation to commercializing
              bioethanol production using lignocellulosic biomass is the
              presence of a complex assembly of polymers such as cellulose,
              hemicelluloses, and lignin that are naturally recalcitrant to
              enzymatic conversion. Pretreatment to break the recalcitrant
              structure is crucial to make cellulose accessible to enzymatic
              saccharification. Assessment of the biochemical composition of
              lignocellulosic biomass aids in developing appropriate
              pretreatment technologies for the deconstruction of rigid
              structure and in selecting enzymes to release the fermentable
              sugars for bioethanol production.
            </p>
            <p>
              During hydrolysis, lignocellulosic biomass is broken down into
              several compounds other than glucose, such as weak acids, furans,
              and phenolic compounds, which are inhibitors in the fermentation
              process. Alkali pretreatments using NaOH, KOH, CaOH, and Na
              <sub>2</sub>CO<sub>3 </sub>are being widely applied&nbsp; for the
              removal of lignin from lignocellulosic biomass due to the
              efficient removal of ester bonds between lignin, hemicellulose,
              and cellulose. Fermentation of lignocellulosic biomass has been
              carried out using the strain of{" "}
              <em>Saccharomyces cerevisiae, </em>and this strain is unable to
              ferment inhibitor compounds, which were generated during the
              hydrolysis step. Detoxifying these inhibitory compounds are
              performed by extraction with ether or ethyl acetate and treatment
              with alkali or sulfite. Also, using enzymes extracted from either
              ligninolytic or cellulolytic fungi or bacteria for hydrolysis
              would circumvent the detoxification step. Cellulolytic enzymes
              play a vital role in the degradation of lignocellulosic biomass
              and these enzymes have been employed in industries to produce
              fermentable sugars. Fungal cellulases are most employed as they
              are inducible enzymes excreting into the environment.
            </p>
            <p>
              This article presents the prospects of biofuel from agriculture
              residues based on the distribution of major biomass (rice and
              wheat) residues across India, which is an important factor in
              assessing the feasibility of plant installation for bioethanol
              production, and also discusses the challenges in the technology so
              far. Bioethanol production from rice and wheat straw using marine
              cellulolytic bacterial for hydrolysis and fermentation using
              isolated yeast strain <em>Pichia kudriavzevii</em>.
            </p>
            <table width="102%" align="center">
              <tbody>
                <tr>
                  <td style={styles.cell} width="100%">
                    <p style={{ textAlign: "center" }}>
                      Kharif: From June/July-October, Rabi: From
                      October/November-March/April, Zaid/Summer: From April-June
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
